import { useEffect, useState } from 'react';

import useTranslationText from 'Shared/Translation/useTranslationText';

type TimeLeftType = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  finished: boolean;
};

type CountdownTimerFromUnixProp = {
  unixSecond: number | null | undefined;
  handleCountdownTimeFinished?: () => void;
};

const CountdownTimerFromUnix: React.FunctionComponent<CountdownTimerFromUnixProp> = ({
  unixSecond,
  handleCountdownTimeFinished,
}) => {
  const [translation] = useTranslationText();

  const [timeLeft, setTimeLeft] = useState<TimeLeftType | null>(null);

  const calculateTimeLeft = async () => {
    const now: number = Math.floor(new Date().getTime() / 1000);
    const next: number = unixSecond ?? now;
    const difference = (next - now) * 1000;

    let timeLeft: TimeLeftType;

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
        finished: false,
      };
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        finished: true,
      };
    }

    if (timeLeft.finished && handleCountdownTimeFinished) {
      handleCountdownTimeFinished();
    }

    return timeLeft;
  };

  const timer = setTimeout(() => {
    calculateTimeLeft().then((timeLeft) => {
      setTimeLeft(timeLeft);
    });
  }, 1000);

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <>
      <div className='d-flex justify-content-between align-items-center px-1'>
        <span className='text-muted m-0'>{`${translation('REMAINING_TIME')} : `}</span>
        <div>
          {timeLeft ? (
            <>
              {timeLeft.finished ? (
                <span className='text-danger'>{translation('TIME_OUT')}</span>
              ) : (
                <div className='d-flex dir-ltr'>
                  <span>{timeLeft.hours}:</span>
                  <span>{timeLeft.minutes}:</span>
                  <span>{timeLeft.seconds}</span>
                </div>
              )}
            </>
          ) : (
            <span className='fw-lighter text-muted m-0' style={{ fontSize: '0.5rem' }}>
              {translation('CALCULATING')}
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default CountdownTimerFromUnix;
